export default "__VITE_ASSET__1fababd0__"